export function showError(messageElement: HTMLDivElement, message?: string) {
    showMsg(messageElement, 'col-sm-6 alert alert-dismissible fade show alert-danger', message);
}

export function showSuccess(messageElement: HTMLDivElement, message?: string) {
    showMsg(messageElement, 'col-sm-6 alert alert-dismissible fade show alert-success', message);
}

function showMsg(messageElement: HTMLDivElement, className: string, message?: string) {
    if (!message) {
        messageElement.hidden = true;
    }
    else {
        messageElement.textContent = message;
        messageElement.className = className;
        messageElement.hidden = false;
    }
}
